import ReactD3MultiSeriesChart from "../../../../AxiomComponents/AxiomUI/ReactD3MultiSeriesChart/ReactD3MultiSeriesChart";

function kpiValueComparedToRedOrangeTargetComponent(
  componentName,
  availableHeight,
  availableWidth,
  data,
  appName,
  appID,
  field,
  value,
  pointInfo
) {
  data = data.sort((a, b) => {
    return new Date(a.Month).getTime() - new Date(b.Month).getTime();
  });
  // console.log(pointInfo);
  const totalPoints = data.length;
  const negativePoints = data.length;
  // const total_days_in_month = +pointInfo.data.total_days_in_month;
  // const remaining_days_in_month = total_days_in_month - totalPoints;
  const title = [
    { text: `${negativePoints} out of ${totalPoints}`, class: "highlight" },
    { text: `months are having negative growth for ${field}` },
    { text: value, class: "highlight" },
  ];
  const chartData = {
    id: AxiomAPIs.generateUUID(16, "aA"),
    config: {
      width: availableWidth,
      height: availableHeight,
      title: {
        text: "",
      },
      subtitle: {
        text: "",
      },
      data: data,
      margins: {
        top: 10,
        right: 50,
        bottom: 30,
        left: 60,
      },
      globalTooltip: true,
      xAxis: [
        {
          categories: data.map((d) => d.Month),
          orient: "bottom",
          crosshair: false,
          lineColor: "#808080",
          lineWidth: 0.5,
          tickColor: "#808080",
          tickLineRequired: true,
          tickWidth: 0.5,
          labels: {
            style: {
              color: "white",
              fontSize: "14px",
            },
            format: "",
            prefix: "",
            postfix: "",
          },
          gridLineWidth: 1,
        },
      ],
      yAxis: [
        {
          orient: "left",
          title: {
            text: "",
            style: {
              color: "white",
            },
          },
          zeroBase: false,
          crosshair: false,
          lineColor: "#808080",
          lineWidth: 0.01,
          tickColor: "#808080",
          tickLineRequired: false,
          ticks: 4,
          tickWidth: 0.5,
          stackLabels: {},
          labels: {
            style: {
              color: "white",
              fontSize: "14px",
            },
            format: "0.[0]",
            prefix: "",
            postfix: "",
          },
        },
      ],
      series: [
        {
          type: "line",
          yAxis: 0,
          name: "KPI Value",
          data: data.map((d) => {
            return { data: +d.Growth, fillColor: getDotColor(d) };
          }),
          dataLabels: {
            enabled: false,
            style: {
              fill: "white",
              fontSize: "12px",
            },
          },
          lineStyle: {
            strokeWidth: "1.2",
            fillColor: "#4aa4b8",
          },
          marker: {
            symbol: "circle",
            fillColor: "#4aa4b8",
            radius: "5px",
          },
        },
        {
          type: "line",
          yAxis: 0,
          name: "Orange Target",
          data: data.map((d) => +d["Orange_Target"]),
          dataLabels: {
            enabled: false,
            style: {
              fill: "white",
              fontSize: "12px",
            },
          },
          lineStyle: {
            strokeDashArray: "5 3",
            strokeWidth: "1.2",
            fillColor: "orange",
          },
        },
        {
          type: "line",
          yAxis: 0,
          name: "Red Target",
          data: data.map((d) => +d["Red_Target"]),
          dataLabels: {
            enabled: false,
            style: {
              fill: "white",
              fontSize: "12px",
            },
          },
          lineStyle: {
            strokeDashArray: "5 3",
            strokeWidth: "1.2",
            fillColor: "red",
          },
        },
      ],
      legend: [],
    },
  };
  const component = (
    <ReactD3MultiSeriesChart {...chartData} appName={appName} appID={appID} componentID="0" />
  );
  // const component = <div />
  return { title, component };
}

function getDotColor(d) {
  if (+d["Red_Target"] <= +d["Orange_Target"]) {
    // higher is better
    return +d.Growth <= +d["Red_Target"]
      ? "red"
      : +d.Growth <= +d["Orange_Target"]
      ? "orange"
      : "green";
  } else {
    // lower is better
    return +d.Growth >= +d["Red_Target"]
      ? "red"
      : +d.Growth >= +d["Orange_Target"]
      ? "orange"
      : "green";
  }
}
module.exports = kpiValueComparedToRedOrangeTargetComponent;
